<app-modal-card>
  <p class="text-[68px] leading-none" aria-hidden="true">⚠️</p>

  <p class="text-[19px] font-semibold fg-noir-1 text-center mt-[28px]">{{ title() }}</p>

  <p class="text-[14px] fg-gris-1 text-center mt-[12px]">
    {{ currentBalanceLabel() }}
    <span class="font-semibold fg-noir-2">{{ currentBalanceAmount() }}</span
    >.
  </p>
  <p class="text-[14px] fg-gris-1 text-center">
    {{ requiredAmountLabel() }}
    <span class="font-semibold fg-noir-2">{{ requiredAmountAmount() }}</span
    >.
  </p>

  <div class="flex flex-col gap-[10px] w-[400px] mt-auto">
    <button
      type="button"
      class="h-[58px] w-full flex items-center justify-center border border-solid border-gris-3 rounded-[5px] text-[16px] font-medium fg-noir-2 cursor-pointer"
      (click)="backToSelectionClick.emit()"
    >
      {{ backToSelectionLabel() }}
    </button>
    <button
      type="button"
      class="h-[58px] w-full flex items-center justify-center border border-solid border-gris-3 rounded-[5px] text-[16px] font-medium fg-noir-2 cursor-pointer"
      (click)="saveAndBackClick.emit()"
    >
      {{ saveAndBackLabel() }}
    </button>
    <button
      type="button"
      class="h-[58px] w-full flex items-center justify-center bg-rose-1 rounded-[5px] text-[16px] font-semibold fg-blanc cursor-pointer"
      (click)="forcePassageClick.emit()"
    >
      {{ forcePassageLabel() }}
    </button>
  </div>
</app-modal-card>
